import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';
import { Pagination } from '@src/api/types/pagination';
import { IndexRequest } from '@src/api/types/shared/request';

export type Company = {
  id: number;
  name: string;
  family_name: string;
  first_name: string;
  created_on: string;
  status: boolean;
};

export type CompanyIndexResponse = {
  data: Company[];
  pagination: Pagination;
};

export type CompanyShowResponse = {
  id: number;
  name: string;
  name_kana: string;
  enabled: boolean;
  industry: string;
  postal_code: string;
  prefecture_code: string;
  address: string;
  family_name: string;
  first_name: string;
  family_name_kana: string;
  first_name_kana: string;
  birthday: string;
  establishment_year: string;
  fiscal_month: string;
  service_description: string;
  revenus_scale: string;
  employee_scale: string;
  approval_status: string;
};

export type CompanyUpdateRequest = {
  company: {
    name: string;
    name_kana: string;
    enabled?: boolean;
    industry: string;
    postal_code: string;
    prefecture_code: string;
    address: string;
    family_name: string;
    first_name: string;
    family_name_kana: string;
    first_name_kana: string;
    birthday: string;
    establishment_year?: string;
    fiscal_month?: string;
    service_description?: string;
    revenus_scale: string;
    employee_scale: string;
  };
};

export type CompanyUpdateResponse = unknown;

export type CompanyUpdateErrorResponse = {
  company: {
    name: string[];
    name_kana: string[];
    enabled: string[];
    industry: string[];
    postal_code: string[];
    prefecture_code: string[];
    address: string[];
    family_name: string[];
    first_name: string[];
    family_name_kana: string[];
    first_name_kana: string[];
    birthday: string[];
    establishment_year: string[];
    fiscal_month: string[];
    service_description: string[];
    revenus_scale: string[];
    employee_scale: string[];
  };
};

export const companyApiClient = {
  index: async (params: IndexRequest = {}): Promise<ApiResult<CompanyIndexResponse>> => {
    return await axiosClient.get('/tenant/companies', { params });
  },
  show: async (id: number): Promise<ApiResult<CompanyShowResponse>> => {
    return await axiosClient.get(`/tenant/companies/${id}`);
  },
  update: async (
    id: number,
    params: CompanyUpdateRequest,
  ): Promise<ApiResult<CompanyUpdateResponse, CompanyUpdateErrorResponse>> => {
    return await axiosClient.put(`/tenant/companies/${id}`, params);
  },
  delete: async (id: number): Promise<ApiResult> => {
    return await axiosClient.delete(`/tenant/companies/${id}`);
  },
};
